import * as d3 from "d3";
import { useEffect, useRef } from "react";

type WeeklyBarChartTotalDataProps = {
  totalKeys: string[];
  totalMap: Map<string, number>;
  totalBarHeight: number;
  totalBarY: number;
  totalBarX: d3.ScaleLinear<number, number>;
};

export function WeeklyBarChartTotalData({
  totalKeys,
  totalMap,
  totalBarHeight,
  totalBarY,
  totalBarX,
}: WeeklyBarChartTotalDataProps) {
  const layerRef = useRef<SVGGElement>(null);

  useEffect(() => {
    if (!layerRef.current) return;
    const selection = d3.select(layerRef.current);

    // 再描画のためクリア
    selection.selectAll("*").remove();

    let totalAcc = 0;
    totalKeys.forEach((key) => {
      const value = totalMap.get(key) ?? 0;
      const x0 = totalBarX(totalAcc);
      const w = totalBarX(value) - totalBarX(0);
      const rect = selection
        .append("rect")
        .attr("class", key)
        .attr("x", x0)
        .attr("y", totalBarY)
        .attr("width", 0)
        .attr("height", totalBarHeight)
        .attr("shape-rendering", "crispEdges")
        .attr("rx", 2)
        .attr("ry", 2);

      rect.transition().duration(600).ease(d3.easeCubicOut).attr("width", w);

      totalAcc += value;
    });
  }, [totalKeys, totalMap, totalBarHeight, totalBarY, totalBarX]);

  return (
    <g
      ref={layerRef}
      className="total-data-layer"
    />
  );
}
